<template>
  <div ref="options-dropdown" class="col-md-4 px-0 options-dropdown" style="display: flex;">
    <jet-button v-if="account_balance > 0" style="display:flex; width: 100px; justify-content: center; align-items: center;" btnStyle="primary" icon="fas fa-dollar-sign" class="py-1 bar-button" :goesTo="route('mtd.billing', 'charges')">Pay</jet-button>
    
    <div @click="toggled = !toggled" class="selected d-flex justify-content-end">
      <div class="d-flex align-items-center">Create New<i class="fas fa-sort-down down-icon"></i></div>
      <ul v-if="toggled" class="dropdown-options m-0 p-0">
        <li data-toggle="modal" data-target="#locationModal" @click="openAdd"><i class="fas fa-map-marker-alt mr-2 text-primary"></i>Location</li>
        <li @click="newUser"><i class="fas fa-user mr-2 text-primary"></i>User</li>
      </ul>
    </div>

    <AddNewLocation v-if="add" :states="states" :form="form" @saveLocation="saveLocation" @beforeSaveLocation="beforeSaveLocation" />
  </div>
</template>

<script>
  import AddNewLocation from '@/Components/Modals/AddNewLocation'
  import LocationVisit from '@/Components/Dashboard/LocationVisit'

  export default {
    data() {
      return {
        toggled: false,
        add: false,
        form: this.$inertia.form({
          company_name: null,
          address1: null,
          address2: null,
          city: null,
          state: null,
          postcode: null,
          location_visit_on_day: null
        }),
      }
    },
    props: {
      states: Array,
      location: Object,
      account_balance: Number,
    },
    components: {
      AddNewLocation,
      LocationVisit
    },
    mounted() {
      window.addEventListener('click', this.clickedOutside)
    },
    unmounted() {
      window.removeEventListener('click', this.clickedOutside)
    },
    methods: {
      openAdd() {
        this.add = true;
      },
      clickedOutside(event) {
        if (!this.$refs['options-dropdown'].contains(event.target)) this.toggled = false
      },
      newUser() {
        this.$inertia.visit(route('shop.create'))
      },
      saveLocation(form) {
        this.$emit('saveLocation', form)
      },
      beforeSaveLocation() {
        this.$emit('beforeSaveLocation')
      }
    }
  }
</script>

